import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
  Label,
} from "recharts";
import useEnrollmentHook from "../hooks/EnrollmentHook";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const CreditHours = ({ schoolId }) => {
  const { data, loading, error } = useEnrollmentHook(schoolId);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  // Generate an array of random colors for each bar
  const colors = data.map(() => getRandomColor());

  const maxValue = Math.max(...data.map((d) => d.Credit_Hours));

  return (
    <Card>
      <CardHeader
        title="Credit Hours"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        <div style={{ width: "100%", height: 400 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="Year">
                <Label value="Year" offset={-5} position="insideBottom" />
              </XAxis>
              <YAxis
                tickFormatter={(value) => value.toLocaleString()}
                domain={[0, maxValue]}
                tickCount={10}
              >
                <Label value="# Enrolled" angle={-90} position="insideLeft" />
              </YAxis>
              <Tooltip />
              <Bar dataKey="Credit_Hours">
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default CreditHours;
